// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 알림 유형 관리 화면 */

.atp-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  padding: 10px 14px;
}

.atp-embedded {
  padding: 0;
  overflow: visible;
}

/* 안내문 */
.atp-info-box {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  color: #444;
  background: #f0f7ff;
  border: 1px solid #b3d4f5;
  border-radius: 5px;
  padding: 8px 12px;
  flex-shrink: 0;
}
.atp-info-icon { font-size: 14px; flex-shrink: 0; }

/* 툴바 */
.atp-toolbar {
  flex-shrink: 0;
  padding: 4px 0;
}

/* 메시지 */
.atp-msg {
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 4px;
  flex-shrink: 0;
}
.atp-msg-success { background: #e8f5e9; color: #2e7d32; }
.atp-msg-error   { background: #ffebee; color: #c62828; }

/* 그리드 */
.atp-grid-wrap {
  flex: 1 1;
  overflow: auto;
  border: 1px solid #dde2ef;
  border-radius: 4px;
  min-height: 0;
}

.atp-grid th,
.atp-grid td {
  font-size: 12px;
  white-space: nowrap;
  padding: 5px 8px;
}

.atp-thresh-up { color: #d32f2f; }
.atp-thresh-dn { color: #1565c0; }

/* 활성 배지 */
.atp-badge {
  display: inline-block;
  padding: 2px 7px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}
.atp-badge-on  { background: #e3f2fd; color: #1565c0; }
.atp-badge-off { background: #f5f5f5; color: #999; }

/* 팝업 폭 확장 */
.atp-popup-wide {
  width: 520px !important;
}

/* 모달 바디 */
.atp-modal-body {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

/* 입력 안내 힌트 */
.ap-hint {
  font-size: 11px;
  color: #888;
  margin-left: 6px;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/AlertTypePage.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA,iBAAiB,eAAe,EAAE,cAAc,EAAE;;AAElD,OAAO;AACP;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,QAAQ;AACR;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;;AAExD,QAAQ;AACR;EACE,SAAO;EACP,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iBAAiB,cAAc,EAAE;AACjC,iBAAiB,cAAc,EAAE;;AAEjC,UAAU;AACV;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;AACtD,iBAAiB,mBAAmB,EAAE,WAAW,EAAE;;AAEnD,YAAY;AACZ;EACE,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["/* 알림 유형 관리 화면 */\n\n.atp-content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  padding: 10px 14px;\n}\n\n.atp-embedded {\n  padding: 0;\n  overflow: visible;\n}\n\n/* 안내문 */\n.atp-info-box {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  font-size: 12px;\n  color: #444;\n  background: #f0f7ff;\n  border: 1px solid #b3d4f5;\n  border-radius: 5px;\n  padding: 8px 12px;\n  flex-shrink: 0;\n}\n.atp-info-icon { font-size: 14px; flex-shrink: 0; }\n\n/* 툴바 */\n.atp-toolbar {\n  flex-shrink: 0;\n  padding: 4px 0;\n}\n\n/* 메시지 */\n.atp-msg {\n  font-size: 12px;\n  padding: 4px 10px;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n.atp-msg-success { background: #e8f5e9; color: #2e7d32; }\n.atp-msg-error   { background: #ffebee; color: #c62828; }\n\n/* 그리드 */\n.atp-grid-wrap {\n  flex: 1;\n  overflow: auto;\n  border: 1px solid #dde2ef;\n  border-radius: 4px;\n  min-height: 0;\n}\n\n.atp-grid th,\n.atp-grid td {\n  font-size: 12px;\n  white-space: nowrap;\n  padding: 5px 8px;\n}\n\n.atp-thresh-up { color: #d32f2f; }\n.atp-thresh-dn { color: #1565c0; }\n\n/* 활성 배지 */\n.atp-badge {\n  display: inline-block;\n  padding: 2px 7px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 600;\n}\n.atp-badge-on  { background: #e3f2fd; color: #1565c0; }\n.atp-badge-off { background: #f5f5f5; color: #999; }\n\n/* 팝업 폭 확장 */\n.atp-popup-wide {\n  width: 520px !important;\n}\n\n/* 모달 바디 */\n.atp-modal-body {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n/* 입력 안내 힌트 */\n.ap-hint {\n  font-size: 11px;\n  color: #888;\n  margin-left: 6px;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
